import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {IFiltersInteractionEvent} from "../types/IFiltersInteractionEvent";
import {IHitFiltersInteractionParams} from "../types/IHitFiltersInteractionParams";

export function hitFiltersInteraction(action: IFiltersInteractionEvent["event_action"], params: IHitFiltersInteractionParams) {
    hitGoogleTagManager({
        event: "filters",
        event_action: action,
        event_label: params.budgetType,
        event_category: params.budget,
        event_category2: params.propertyType,
        event_category3: params.rooms,
        event_category4: params.area,
        event_category5: params.deliveryTime
    });
}
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";
import {IFiltersInteractionEvent} from "../types/IFiltersInteractionEvent";
import {IHitFiltersInteractionParams} from "../types/IHitFiltersInteractionParams";

export function hitFiltersInteraction(action: IFiltersInteractionEvent["event_action"], params: IHitFiltersInteractionParams) {
    hitGoogleTagManager({
        event: "filters",
        event_action: action,
        event_label: params.budgetType,
        event_category: params.budget,
        event_category2: params.propertyType,
        event_category3: params.rooms,
        event_category4: params.area,
        event_category5: params.deliveryTime
    });
}
